// @ts-nocheck

import COUNTRY from "../constants/COUNTRY";

export const phoneNumberWithOrWithoutZero = (phoneNumber: string = "", withZero = false) => {
  try {
    const matched = phoneNumber.match(/6[0-9]{8}|7[0-9]{8}$/);
    if (!matched) {
      return phoneNumber;
    }
    return `${withZero ? "0" : ""}${matched[0]}`;
  }
  catch (err) {
    ErrorLoggerService("APP", "customerObjectConvert", err);
    return phoneNumber;
  }
};

type FormToModelOptions = {
  withoutPassword?: boolean;
}

export const formToModel = (formObject: Object = {}, options: FormToModelOptions = { withoutPassword: false }): Object => {
  const {
    birthDate,
    mobilePhone,
    password,
    password2,
    ...rest
  } = formObject;


  return {
    birthDate,
    mobilePhone: phoneNumberWithOrWithoutZero(mobilePhone),
    countryCode: COUNTRY.countryCode,
    ...(options.withoutPassword ? { } : {
      password,
      password2
    }),
    ...rest
  };

};
